import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as S from './../../pages/ReviewPage/ReviewPage.styles';
import Icon from './../../../stories/core-components/IconsSelector';
import BookingDetailCard from './../../pages/ReviewPage/components/BookingDetailCard/BookingDetailCard';
import TravellerBlock from './../../pages/ReviewPage/components/ReviewCard/ReviewCard';
import TripType from './../../pages/ReviewPage/components/TripTypeCard/TripTypeCard';
import FarePrice from './../../pages/ReviewPage/components/FarePriceCard/FarePriceCard';
import ReviewOfferCard from './../../pages/ReviewPage/components/OfferCard/OfferCard';
import InsuranceBlock from './../../pages/ReviewPage/components/InsuranceBlock/InsuranceBlock';
import { fetchReviewData, fetchPromoData, callTentativeAPI, setData, callGoSafeMeasure, callSocialDistance } from './redux/thunks';
import { getter, getterSessionStorage } from '@stencil/client-side-storage';
import dateformat from 'dateformat';
import { validations } from './InputValidation';
import { TripTypeConfig } from './Config';
import { useHistory } from 'react-router-dom';
import { dataLoadingSelector, isErrorSelector, goSafeSelector, goSafeSocialSelector, reviewDataSelector, isPromoAndGoCashBothAllowedSelector, selectedPromoIdSelector, goCashSelector } from './redux/selectors';
import { PROMO_DISPLAY_COUNT } from './Config';
import { fetchCancellationPolicy } from './../SeatLayout/redux/thunks';
import Popup from './../../../stories/core-components/Popup/Popup';
import AlertPopup from './../../../stories/core-components/ErrorAlert/ErrorAlert';
import SignInTag from './../../pages/ReviewPage/components/SigninSignupTags/SignInTags';
import BookingPageLoader from '../../pages/ReviewPage/components/BookingPageLoader/BookingPageLoader';
import { scrollEletoView, getQueryString, signIn, prepareSRPURL, getNewPayments, pushDataToNewrelic } from './../../containers/Common/Utils';
import { IUserStoreState, userSelector } from '@stencil/user-reducer';
import { REVIEW_PAGE, PAYMENT_PAGE } from './../../config/messages';
import GoSafeMeasures from '../../pages/ReviewPage/components/GoSafeMeasures/GoSafeMeasures';
import GoSafeImpInfo from '../../pages/ReviewPage/components/GoSafeImpInfo/GoSafeImpInfo';
import { getCookie, getJourneyDetails } from './Utils'
import { pushga, pushEcommerceGAEvent } from 'ga-utils';
import { ReviewEvents } from './../../config/ga-config';
import getDateObj from './../../utils/GetDateObj'
import SubmitedDetails from '../../pages/ReviewPage/components/SubmitedDetails/SubmitedDetails';
import PaymentPageLoader from '../../pages/ReviewPage/components/PaymentPageLoader/PaymentPageLoader';
import { useAsync } from 'react-async';
import awesomeDebouncePromise from 'awesome-debounce-promise';
import useConstant from 'use-constant';
import GoTribeBanner from './../../components/GoTribe/Banner/BannerHOC';
import ReviewGoTribe from './../../components/GoTribe/Review/ReviewGoTribe';
import { Helmet } from 'react-helmet';
import { toggleReviewDataLoading, setSelectedPromoCode, toggleGoCashSelection } from './redux/actions';
import CollapsibleComponent from '../../components/CollapsibleComponent';
import TravellerContactForm from '../../pages/ReviewPage/components/TravellerContactForm/TravellerContactForm';
import GoCash from '../../pages/ReviewPage/components/GoCashBanner/GoCash';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, calculateDroppingDate, seatNumberMethod, availableOffers, fareBreakupHelper } from '../../utils/ctaHelper'
import { commonSelector, routeStateSelector } from '../../containers/Common/redux/selectors'
import { CTA_TYPE, pushOmniEvents } from '../../utils/PushEvents/Omniture/utils';
import { pushCtaOmniEvents } from '../../utils/PushEvents/Omniture/clickEvents';
import { userLoyaltyInfo } from '../Home/redux/selectors';
import { srpCardIndex } from '../SRP/redux/selectors';
import { BillingDetailsDweb } from '@growth/billing-details/dweb';
import { GoTribeReview } from '@growth/gotribe/goTribeReview';
import { GoTribeSideStrip } from '@growth/gotribe/goTribeSideStrip';

const Review = props => {
  const { search, hash } = props.location;
  const history = useHistory();
  const dataLoading = useSelector(dataLoadingSelector);
  const isError = useSelector(isErrorSelector);
  const userDetails = useSelector(userSelector) as IUserStoreState;
  const {userInfo, loyaltyInfo={}} = userDetails;
  const goSafeData = useSelector(goSafeSelector);
  const goSafeSocialData = useSelector(goSafeSocialSelector);
  const reviewDataFromStore = useSelector(reviewDataSelector);
  // const {bottomStrip=[], inLineCard=[], type=''} = dummyGoTribe
  const commonData = useSelector(commonSelector);
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const isuserWidgetLoading = !!userDetails?.isLoading;
  const allow_both_promo_and_gocash = useSelector(isPromoAndGoCashBothAllowedSelector);
  const {reddeal } = reviewDataFromStore;
  const billingAddressRef = useRef<HTMLElement>(null);
  const dispatch = useDispatch();
  const srpCardInd = useSelector(srpCardIndex)
  //const [data, updateReviewData] = useState({});
  const [businessInfo, setBusinessInfo] = useState({
    gstNumber: '',
    companyName: '',
    companyAddress: '',
    businessMail: '',
    phoneNumber: '',
    country: '',
    state: '',
    gstNumberErr: '',
    companyNameErr: '',
    companyAddressErr: '',
    businessMailErr: '',
    phoneNumberErr: '',
    countryErr: '',
    stateErr: '',
    countryCode: '+91',
    contactNumberMaxLength: 10
  });

  const [travellerData, setTravellerData] = useState([]);
  const [flag, setFlag] = useState(1)
  const selectedPromoId = useSelector(selectedPromoIdSelector);
  const isGocashSelected = useSelector(goCashSelector);
  const [popupContent, setPopupContent] = useState({ title: '', content: '' });
  const [alertPopupContent, setAlertPopupContent] = useState({ title: '', content: '', isHeaderIcon: false, footerBtn: false, buttonName: "", onFooterBtnClick: () => { } });
  const [contactInfo, setContactInfo] = useState(getInitContactInfo());
  const [insuranceOption, setInsuranceOption] = useState({ value: '', err: '', collapsed: false, isLoading: false });
  const [offerAction, setOfferAction] = useState({ isPromo: false, isGocash: false, promoName: "" });
  const [collapsedItems, setCollapsedItems] = useState({ traveller: false, contactDetail: false, fare: false, offer: false });
  const [tripType, setTripType] = useState({ type: TripTypeConfig[0].id, collapsed: false });
  const routeStates = useSelector(routeStateSelector)
  const userLoyalty = useSelector(userLoyaltyInfo)
  const userTier = userLoyalty?.userLoyaltyInfo?.user_tier == undefined ? '' : `${userLoyalty?.userLoyaltyInfo?.user_tier}`
  const [categoryCardInfo, setCategorycardInfo] = useState({
    catCardNumber: '',
    srCitizenCardNumber: '',
    catCardErr: '',
    srCitizenCardErr: ''
  })

  const [paymentFareBreakup, setFareBreakup] = useState({
    totalPayFare: 0,
    breakup: {}
  });

  const [paymentPageInfo, setPaymentPageView] = useState({ isPaymentPage: false, isLoading: false, isError: false });
  const [sendPageViewCnt, setSendPageViewCnt] = useState(0)
  let src = '',
    dest = '',
    doj = '',
    persuasionText = "",
    bookingDetailCardProps = {},
    insurance = {},
    totalPayFare = '',
    seatsSelected = [],
    bookingKey = '',
    routeId = '',
    token = '',
    querydata = '',
    pax_prefill = [],
    promos = [],
    promo_applied = {},
    other_data: {},
    soc_dis = false,
    go_safe = false,
    review_info: {},
    review_ps: { t: '', tg_list: [] },
    goTribeCoinData: {},
    page_source = '',
    fareBreakup = {},
    redDeal = {},
    is_sponsored='',
    is_bo_ads='';

  if (search) {
    bookingKey = getQueryString('bookingKey', search);
    routeId = getQueryString('routeId', search);
    token = getQueryString('token', search);
    querydata = getQueryString('querydata', search);
    page_source = getQueryString('page_source', search);
    is_sponsored = getQueryString('is_sponsored', search);
    is_bo_ads=getQueryString('is_bo_ads', search)
  }
  const busLSdata = getterSessionStorage('bus');

  const redirectToSrpWithRouterId = () => {
    const onward = reviewDataFromStore?.onward_data;
    try {
      const srpURL = prepareSRPURL({
        src_name: onward.origin,
        dest_name: onward.destination,
        selectedDate: function () {
          if (onward.depdate) {
            return getDateObj(onward.depdate.replace("Z", ""))
          }
          return getDateObj();
        }(),
        src_vid: onward.src_voyager_id,
        dest_vid: onward.dest_voyager_id,
        routeId: routeId
      });
      history.push(srpURL);
    } catch (err) {
      console.warn(err);
    }
  }

  const myDoj = convert_yyyymmdd_to_dd_mm_dddd(commonData?.doj)
  useEffect(()=>{
    setTimeout(()=>{
      setSendPageViewCnt(1)
    }, 1000)
  },[])
  
  useEffect(() => {
    if (flag && Object.keys(reviewDataFromStore).length > 0 && sendPageViewCnt === 1) {
      const { onward_data, total_pay_fare, fare_breakup } = reviewDataFromStore;
      const { seatsSelected, DepartureTime, ArrivalTime, BoardingPoint, DroppingPoint, duration, rating, origin, destination} = onward_data;
      let discount;
      if(reviewDataFromStore?.fare_excluding_discounts){
        discount = `${Math.round(Math.abs(reviewDataFromStore?.fare_excluding_discounts - reviewDataFromStore?.total_pay_fare))}`
      }  else{
        discount = `0`
      }
      const eventDetails = {
          page: {
            pageInfo: {
              section: "domestic bus funnel",
              pageName: "funnel:domestic bus:review",
              pageType: "funnel",
              lob: "domestic bus",
              siteName: 'GI',
              platform: 'dweb',
              flow: "direct-bus",
              loadedComponents: 'Bus Summary|Insurance Section|Traveller Details|Trip Type|Price Component|goCash Component|Offers Component',
              abVariant: '',
              deviceId: "",
              loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`            },
          },
          account: {
            accountInfo: {
              custID: userInfo?.userid ? `${userInfo?.userid}` : '',
              loginStatus:  isLoggedIn? "Logged-In" : "Guest",
              goCash: userDetails?userDetails.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "":'',
              loyaltyStatus: userTier,
              "hydraSegment": "",
            },
          },
          productListItems: [{
              SKU: onward_data?.bid,
              productInfo: {
                  productName: onward_data?.TravelsName,
                  productPosition: srpCardInd ? `${srpCardInd}` : '',
                  busNitroDealsBanner: reddeal?.is_nitro ? 'Y':'N' ,
                  "busLoginDealsBanner": reddeal?.is_reddeal_applicable ? 'Y':'N',
              }
          }],
          booking: {
              routeCity: `${origin}-${destination}`,
              routeState : (routeStates.srcState && routeStates.destState) ?  `${routeStates.srcState}-${routeStates.destState}` : '',
              daysToTrip: `${calculateDaysToTrip(commonData?.dojObj)}`,
              departureDate: `${myDoj}`,
              droppingDate:calculateDroppingDate(myDoj,DepartureTime, ArrivalTime),
              departureTime: `${DepartureTime}`,
              droppingTime: `${ArrivalTime}`,
              boardingPoint:`${BoardingPoint?.BPN}`,
              droppingPoint:`${DroppingPoint?.DPN}`,
              duration: `${duration}`,
              Ratings: `${rating}`,
              seatNumber:`${seatNumberMethod(seatsSelected)}`,
              numberOfSeats:`${seatsSelected?.length}` || '0',
              baseFare: `${fareBreakupHelper(fare_breakup, "Total Basefare")}`,
              taxAmount: `${fareBreakupHelper(fare_breakup, "Operator GST")}`,
              discount: discount,
              finalBookingValue:`${total_pay_fare}`,
              offerId:availableOffers(promos)
          },
        }
        pushOmniEvents({ eventName: 'pageView', details: eventDetails });
        setFlag(0)
  }  
  },[sendPageViewCnt, promos])
 
  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        redirectToSrpWithRouterId();
      }
    };
  }, [reviewDataFromStore]);

  function validateUserInput(contactInfo, travellerData, insuranceOption, businessInfo, tripType, other_data, operatorId, operatorName) {
    const { sr_citizen_req, cat_card_required } = other_data;
    let isValid = true;
    if (insurance && Object.keys(insurance).length && !insuranceOption.value) {
      if (isValid) {
        scrollToHead("reviewBlock");
      }
      isValid = false;
      setInsuranceOption({ value: insuranceOption.value, err: 'Insurance Selection is mandatory', collapsed: false, isLoading: insuranceOption.isLoading });
    }

    let isRSRTC = (operatorName && operatorName.toLowerCase().indexOf('rsrtc') !== -1) || operatorId == '15499';
    let isSingleTravellerAgeGreaterThen13 = atLeastTravellerAge13(travellerData, isRSRTC);

    const emailValidationCB = validations['validEmail']; // Calls the function defined in validation.js
    const contactNumberValidationCB = validations['validMobileNumber']; // Calls the function defined in validation.js
    const nameValidationCB = validations['alpha'];
    const catCardValidationCB = validations['alphanumeric'];
    const srCitizenCardValidationCB = validations['alphanumeric'];
    const srCitizenAgeValidationCB = validations['srCitizenAge'];

    /********************************************************************************* */
    let businessDetailInfo = Object.assign({}, businessInfo);
    let categoryInfo = Object.assign({}, categoryCardInfo);
    if (sr_citizen_req) {
      categoryInfo.srCitizenCardErr = srCitizenCardValidationCB(categoryInfo.srCitizenCardNumber, "sr citizen", true, 'Sr Citizen Card Number');

    }
    if (cat_card_required) {
      categoryInfo.catCardErr = catCardValidationCB(categoryInfo.catCardNumber, "cat card", true, 'CAT Card Number');
    }

    if (tripType === 'business') {
      const { gstNumber, companyName, companyAddress, businessMail, phoneNumber, country, state, countryCode } = businessInfo;

      const gstNumberValidationCB = validations['validGSTNumber']; // Calls the function defined in validation.js
      const companyNamAddressValidationCB = validations['alphanumeric']; // Calls the function defined in validation.js
      const businessMailValidationCB = validations['gst_business_email']; // Calls the function defined in validation.js

      businessDetailInfo.gstNumberErr = gstNumberValidationCB(gstNumber, 'GST number', true, "Enter GST Number");
      businessDetailInfo.companyNameErr = companyNamAddressValidationCB(companyName, 'comapany name', true, "Enter Company Name");
      businessDetailInfo.companyAddressErr = companyNamAddressValidationCB(companyAddress, 'company address', true, "Enter Company Address");
      businessDetailInfo.businessMailErr = businessMailValidationCB(businessMail, 'business mail id', true, "Enter Business Email");
      businessDetailInfo.phoneNumberErr = contactNumberValidationCB(phoneNumber, countryCode, "mobile number", true, "Enter Mobile Number");
      businessDetailInfo.countryErr = nameValidationCB(country, "country", "Enter Country");
      businessDetailInfo.stateErr = nameValidationCB(state, "state", "Enter state");

      const { gstNumberErr, companyNameErr, companyAddressErr, businessMailErr, phoneNumberErr, countryErr, stateErr } = businessDetailInfo;

      if (gstNumberErr || companyNameErr || companyAddressErr || businessMailErr || phoneNumberErr || countryErr || stateErr) {
        if (isValid) {
          // setTripType({ ...tripType, collapsed: false });
          scrollToHead("tripTypeBlock")
        }
        isValid = false;
      }
    }

    const { email, contactNum, countryCode } = contactInfo;
    const contactDetails = Object.assign({}, contactInfo);
    contactDetails.emailErr = emailValidationCB(email, "email", true, "Enter Email");
    contactDetails.contactNumErr = contactNumberValidationCB(contactNum, countryCode, "mobile number", true, "Enter Mobile Number");
    /********************************************************************************* */

    const travellerInput = [...travellerData];
    for (const i in travellerInput) {
      if (travellerInput.hasOwnProperty(i)) {
        const { name, age, gender } = travellerInput[i];
        //TODO:- add the validation for senior citizen and student age
        const ageValidationCB = validations['age'];
        const genderValidationCB = validations['validGender'];
        travellerInput[i].nameErr = nameValidationCB(name, "Full Name", "Enter Full Name")
        if (sr_citizen_req) {
          travellerInput[i].ageErr = srCitizenAgeValidationCB(age, true, "Enter Age")
        } else if (isRSRTC && (age < 5 || !isSingleTravellerAgeGreaterThen13)) {
          if (age < 5) {
            travellerInput[i].ageErr = 'Min age must be 5 yrs to book a seat';
          } else if (!isSingleTravellerAgeGreaterThen13) {
            travellerInput[i].ageErr = 'At least one adult (13+ yrs) required';
          }
        } else {
          travellerInput[i].ageErr = ageValidationCB(age, true, "Enter Age");
        }

        travellerInput[i].genderErr = genderValidationCB(gender) ? "Select Gender" : "";
        if (travellerInput[i].nameErr || travellerInput[i].ageErr || travellerInput[i].genderErr) {
          if (isValid) {
            // setCollapsedItems({ ...collapsedItems, traveller: false })
            scrollToHead(`travellerForm${+i + 1}`);
          }
          isValid = false;
          //  break;
        } else {
          addTraveller(travellerInput[i]);
        }
      }
    }
    if (contactDetails.emailErr || contactDetails.contactNumErr || categoryInfo.catCardErr || categoryInfo.srCitizenCardErr) {
      if (isValid) {
        // setCollapsedItems({ ...collapsedItems, contactDetail: false })
        scrollToHead("ContactDetailsBlock")
      }
      isValid = false;
    }
    setCategorycardInfo(categoryInfo);
    setContactInfo(contactDetails);
    setBusinessInfo(businessDetailInfo);
    setTravellerData(travellerInput);
    return isValid;
  }


  function onTentativeFailed(isTentativeFailed, resp) {
    setAlertPopupContent({
      title: 'INFO ', content: `${resp.error}`, isHeaderIcon: true, footerBtn: true, buttonName: 'OK', onFooterBtnClick: () => {
        redirectionOnTentativeFailed(resp, reviewDataFromStore.onward_data);
      }
    });
  }
  function redirectionOnTentativeFailed(tentativeFailedInfo, onward) {
    if (!onward) {
      window.history.back();
      return;
    }
    const srpUrl = prepareSRPURL({
      src_name: onward.origin,
      dest_name: onward.destination,
      selectedDate: function () {
        if (onward.depdate) {
          return getDateObj(onward.depdate.replace("Z", ""))
        }
        return getDateObj();
      }(),
      src_vid: onward.src_voyager_id,
      dest_vid: onward.dest_voyager_id,
      routeId: routeId
    });
 
    switch (tentativeFailedInfo.action) {
      case 'srp':
        window.location.href = srpUrl;
        history.push(srpUrl);
        break;
      case 'seatlayout':
        window.location.href = srpUrl;
        history.push(srpUrl);
        break;
      default:
        history.push(srpUrl);
    }
  }

  
  function callTentativeEvent(label) {
    pushga({
      event: ReviewEvents.actions.tentativeComplete,
      eventCategory: ReviewEvents.category,
      eventAction: ReviewEvents.actions.tentativeComplete,
      eventLabel: label
    });
  }
  function onPayClick(gst_details) {
    let reviewData = busLSdata['reviewCollection'][bookingKey + routeId];
    const { onward_data } = reviewData;
    const { OperatorID, TravelsName, DepartureTime, ArrivalTime, BoardingPoint, DroppingPoint, duration, rating, } = onward_data;
    if (validateUserInput(contactInfo, travellerData, insuranceOption, businessInfo, tripType.type, other_data, OperatorID, TravelsName)) {
      setPaymentPageView({ isPaymentPage: true, isLoading: true, isError: false });
      pushDataToNewrelic(`reviewVal=payClick`);
      scrollToHead("reviewPageHead");
      const { fareTotal, udf1, mobile, email, credits, isSeniorCitizen, isCatCard } = getSubmitProps(
        reviewDataFromStore,
        contactInfo,
        travellerData,
        other_data
      );
      let tentativeAPIObj = {
        fareTotal,
        udf1,
        mobile,
        email,
        credits,
        isSeniorCitizen,
        isCatCard,
        token,
        travellerData,
        querydata: querydata.indexOf('#') !== -1 ? querydata : `#${querydata}`,
        businessInfo,
        tripType: tripType.type,
        srCitizenCardNumber: categoryCardInfo.srCitizenCardNumber,
        catCardNumber: categoryCardInfo.catCardNumber,
        gst_details: JSON.stringify(gst_details),
        is_sponsored:is_sponsored,
        is_bo_ads:is_bo_ads
      }
      let reviewData = busLSdata['reviewCollection'][bookingKey + routeId];
      reviewData['travellerInfo'] = travellerData;
      reviewData['contactInfo'] = contactInfo;
      reviewData['tentativeInfo'] = tentativeAPIObj;

      //  setData({bookingKey, routeId, data:reviewData});
      let discount;
      if(reviewDataFromStore?.fare_excluding_discounts){
        discount = `${Math.round(Math.abs(reviewDataFromStore?.fare_excluding_discounts - reviewDataFromStore?.total_pay_fare))}`
      }  else{
        discount = `0`
      }
      const eventDetails = {
        page: {
          pageInfo: {
            section: "domestic bus funnel",
            pageName: "funnel:domestic bus:review",
            pageType: "funnel",
            lob: "domestic bus",
            siteName: 'GI',
            platform: 'dweb',
            flow: "direct-bus",
            loadedComponents: 'Bus Summary|Insurance Section|Traveller Details|Trip Type|Price Component|goCash Component|Offers Component',
            abVariant: '',
            deviceId: "",
            loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`          },
        },
        account: {
          accountInfo: {
            custID: userInfo?.userid ? `${userInfo?.userid}` : '',
            loginStatus:  isLoggedIn? "Logged-In" : "Guest",
            goCash: userDetails?userDetails.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "":'',
            loyaltyStatus: userTier,
            "hydraSegment": "",
          },
        },
        cta: ctaHelper(['Bus_Seat_Selected', CTA_TYPE.BUTTON, 'Card_Footer', 'Review']),
        productListItems: [{
            SKU: onward_data?.bid,
            productInfo: {
                productName: onward_data?.TravelsName,
                productPosition: srpCardInd ? `${srpCardInd}` : '',
                busNitroDealsBanner: reddeal?.is_nitro ? 'Y':'N',
                "busLoginDealsBanner": reddeal?.is_reddeal_applicable ? 'Y':'N',
            }
        }],
        booking: {
            routeCity: `${src}-${dest}`,
            routeState : (routeStates.srcState && routeStates.destState) ?  `${routeStates.srcState}-${routeStates.destState}` : '',
            daysToTrip: `${calculateDaysToTrip(commonData?.dojObj)}`,
            departureDate: `${myDoj}`,
            droppingDate:calculateDroppingDate(myDoj,DepartureTime, ArrivalTime),
            departureTime: `${DepartureTime}`,
            droppingTime: `${ArrivalTime}`,
            boardingPoint:`${BoardingPoint?.BPN}`,
            droppingPoint:`${DroppingPoint?.DPN}`,
            duration: `${duration}`,
            Ratings: `${rating}`,
            seatNumber:seatNumberMethod(seatsSelected),
            numberOfSeats:`${seatsSelected?.length}` || '0',
            baseFare:  `${fareBreakupHelper(reviewData?.fare_breakup, "Total Basefare")}`,
            taxAmount: `${fareBreakupHelper(reviewData?.fare_breakup, "Operator GST")}`,
            discount: discount,
            tripType: tripType?.type,
            insuranceSelected:reviewDataFromStore?.insurance_applied ? 'Y' : 'N',
            finalBookingValue:`${reviewDataFromStore?.total_pay_fare}`,
            offerId: `${reviewDataFromStore?.promo_applied?.offer_key}`,
            promocode: `${reviewDataFromStore?.promo_applied?.offer_key}`
        },
      };
      if(other_data?.sr_citizen_req){
        eventDetails.booking['busBookingCategory'] = 'Sr. Citizen';
      }
      else{
        eventDetails.booking['busBookingCategory'] ='General';
      }
      pushOmniEvents({ eventName: 'payAndConfirm', details: eventDetails });

      let pageLoadEventTagsJsonStr = {
        page: {
          pageInfo: {
            section: "domestic bus funnel",
            pageName: "funnel:domestic bus:payment",
            pageType: "funnel",
            lob: "domestic bus",
            siteName: 'GI',
            loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`          }
        },
        booking: {...eventDetails.booking}
      }
      tentativeAPIObj['pageLoadEventTagsJsonStr'] = JSON.stringify(pageLoadEventTagsJsonStr)
      dispatch(
        callTentativeAPI(tentativeAPIObj)).then(data => {
          if (data) {
            if (data.error) {
              setPaymentPageView({ isPaymentPage: true, isLoading: false, isError: true });
              onTentativeFailed(true, data);
              return;
            }
            if (data.fare_changed || data.ipc) {
              setPaymentPageView({ isPaymentPage: true, isLoading: false, isError: false });
              setPopupContent({
                title: PAYMENT_PAGE.FARE_CHANGE_TITILE,
                content: PAYMENT_PAGE.FARE_CHANGE_CONTENT,
              });
            }

            if (reviewData.payment_version === 'v2') {
              setPaymentPageView({ isPaymentPage: true, isLoading: false, isError: false });
              callTentativeEvent("success")

              if (data.breakup) {
                setFareBreakup({ totalPayFare: data.final_amount, breakup: getPaymentFareBreakup(data.breakup.breakup, data.f_b_map) });
              }

              if (data.success && parseFloat(data.final_amount) > 0) {
                if (data.payment_ab && data.paydata && data.paydata.pay_url) {
                  window.location.replace(data.paydata.pay_url);
                } else if (window.initPayment) {
                  window.initPayment({
                    paySessionId: data.paydata.pay_id,
                    containerId: 'gi_paymentframe',
                    convFee: 0, // optional
                  });
                  pushEcommerceGAEvent({
                    pageViewEvents: {
                      cdBusSearchDestination: reviewData.onward_data.destination,
                      cdBusSearchOrigin: reviewData.onward_data.origin,
                      cdBusSearchReturnDate: "",
                      cdCatQuery: "bus-domestic",
                      cdSubCatQuery: "OneWay",
                      cdVisitorSegment: "",
                      userid: "",
                    },
                    event: "virtualPageView",
                    virtualPage: "review?page=buspayment",
                  });
                }

              } else if (data.success && parseFloat(data.final_amount) === 0) {
                if (data.creddata?.newCredurl) {
                  window.location.replace(data.creddata.newCredurl);
                } else {
                  const formElm = document.createElement('form');
                  formElm.action = data.creddata.credurl;
                  formElm.method = 'post';
                  document.body.append(formElm);
                  const elemArr = {
                    crdid: data.creddata.crdid,
                    txnid: data.txn_id,
                    status: 'success',
                    payu_amount: data.final_amount,
                    creditsamount1: data.creddata.amount,
                    gocashcheck: data.creddata.gocashcheck,
                  };
                  Object.keys(elemArr).forEach(key => {
                    const inpElem = document.createElement('input');
                    inpElem.type = 'hidden';
                    inpElem.name = key;
                    inpElem.value = elemArr[key];
                    formElm.appendChild(inpElem);
                  });
                  formElm.submit();
                }
              }
            } else {
              callTentativeEvent("version_error")
              setPaymentPageView({ isPaymentPage: true, isLoading: false, isError: true });
            }
          } else {
            callTentativeEvent("error")
            setPaymentPageView({ isPaymentPage: true, isLoading: false, isError: true });
          }
        })
      pushga({
        event: ReviewEvents.actions.pay,
        eventCategory: ReviewEvents.category,
        eventAction: ReviewEvents.actions.pay,
      });
      return;
    } else {
      pushga({
        event: ReviewEvents.actions.validationError,
        eventCategory: ReviewEvents.category,
        eventAction: ReviewEvents.actions.validationError,
      });
      console.log('mandatory fields');
    }
  }

  const scrollToHead = (id?: string) => {
    const idOfElToScrollTo = `#${id || 'bookingPageLoader'}`;
    scrollEletoView(idOfElToScrollTo, {
      behavior: 'smooth',
      block: 'start',
    });
  }

  const isDataPresentinLS =
    busLSdata &&
    busLSdata['reviewCollection'] &&
    busLSdata['reviewCollection'] &&
    busLSdata['reviewCollection'][bookingKey + routeId];


  useEffect(() => {
    if (isDataPresentinLS) {
      token = busLSdata['reviewCollection'][bookingKey + routeId].b_token;
      updateToken(search, history, token);
      dispatch(toggleReviewDataLoading({ isLoading: false, isError: false, reviewData: busLSdata['reviewCollection'][bookingKey + routeId] }));
      scrollToHead();
    }
  }, [dataLoading]);

  const callbackpromo = async ({ }) => {
    return {};
  };

  const debouncedPromo = useConstant(() =>
    awesomeDebouncePromise(callbackpromo, 150)
  );
  const aysncval = useAsync({
    promiseFn: debouncedPromo,
    initialValue: isuserWidgetLoading,
    onResolve: function () { },
    isLoggedin: isLoggedIn,
    isuserWidgetLoading: isuserWidgetLoading,
    isGoCashSelected: isGocashSelected,
    watchFn: function name(params, previousParams) {
      if (!params.isuserWidgetLoading && params.isuserWidgetLoading !== previousParams.isuserWidgetLoading) {
        loadPromoData(params.isLoggedin);
        return true;
      }
      return false;
    }
  });

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(toggleGoCashSelection(true));
    }
  }, [isLoggedIn])

  useEffect(() => {
    if (!isDataPresentinLS && token) {
      dispatch(fetchReviewData({ bookingKey, querydata, token, routeId, page_source }));
    }
    scrollToHead();
    getNewPayments();
    pushDataToNewrelic(`reviewVal=reviewMount`);
    return () => {
      dispatch(setSelectedPromoCode(''));
      dispatch(toggleReviewDataLoading({ isLoading: false, reviewData: {} }))
    }
  }, []);

  useEffect(() => {
    if (isError) {
      setAlertPopupContent({
        title: REVIEW_PAGE.PAGE_LOAD_ERROR_TITILE, content: REVIEW_PAGE.PAGE_LOAD_ERROR, isHeaderIcon: false, buttonName: "OK", footerBtn: true, onFooterBtnClick: () => {
          window.history.back();
        }
      })
    }
  }, [isError])

  if (isError) {
    return <section key="parent">
      <S.ReviewPageBgWrapper id="reviewPageHead">
        <AlertPopup
          popupWidth="57rem"
          isHeaderIcon={false}
          footerBtn={true}
          title={REVIEW_PAGE.PAGE_LOAD_ERROR_TITILE}
          contentTxt={REVIEW_PAGE.PAGE_LOAD_ERROR}
          buttonName={"OK"}
          onFooterBtnClick={() => {
            window.history.back();
          }}
        />

      </S.ReviewPageBgWrapper>
    </section>
  }

  if (paymentPageInfo.isPaymentPage && paymentPageInfo.isLoading) {
    return <PaymentPageLoader></PaymentPageLoader>
  }
  if (dataLoading || !Object.keys(reviewDataFromStore).length) {
    return (
      <BookingPageLoader ></BookingPageLoader>
    )
  }

  if (!Object.keys(reviewDataFromStore).length) {
  } else {
    const journeyDetail = getJourneyDetails(reviewDataFromStore.onward_data);
    src = journeyDetail.src;
    dest = journeyDetail.dest;
    doj = journeyDetail.doj;
    persuasionText = journeyDetail?.persuasionText;
    bookingDetailCardProps = getBookingDetailsCardProps(reviewDataFromStore.onward_data);
    insurance = reviewDataFromStore.insurance;
    totalPayFare = reviewDataFromStore.total_pay_fare;
    seatsSelected = reviewDataFromStore.onward_data.seatsSelected;
    review_ps = reviewDataFromStore.review_ps || { t: '', tg_list: [] };
    goTribeCoinData = reviewDataFromStore.go_tribe;
    pax_prefill = function () {
      let pax_prefill = reviewDataFromStore.pax_prefill || [];
      // let traveller = getter("traveller");
      // if(traveller && Object.keys(traveller).length){
      //   pax_prefill = pax_prefill.concat(Object.values(traveller));
      // }
      return pax_prefill;
    }();
    promos = reviewDataFromStore.promos;
    redDeal = reviewDataFromStore.reddeal;
    promo_applied = reviewDataFromStore.promo_applied;
    if (paymentPageInfo.isPaymentPage) {
      fareBreakup = paymentFareBreakup.breakup;
      totalPayFare = paymentFareBreakup.totalPayFare;
    } else {
      fareBreakup = getFareBreakup(reviewDataFromStore.fare_breakup, reviewDataFromStore.f_b_map);
    }

    other_data = reviewDataFromStore.onward_data.other_data;
    go_safe = other_data.go_safe;
    soc_dis = other_data.soc_dis;
    review_info = reviewDataFromStore.onward_data.review_info;

    if (!Object.keys(goSafeData.data).length && !Object.keys(goSafeSocialData.data).length) {
      loadGosafeChanges();
    }
    if (!travellerData.length) {
      setTravellerData(getTravllerInitInfo(seatsSelected));
    }
  }

  const eventDetailsOffer = {
    booking : {
      offerId: ''
    },
    cta: ctaHelper(['Offer_selected', CTA_TYPE.RADIO_BUTTON, 'Offers', 'Review'])
  }

  function onPromoClick(promoObj, manualPromo=false) {
    if (isGocashSelected && !allow_both_promo_and_gocash) {
      dispatch(toggleGoCashSelection(false));
    }

    setOfferAction({ isGocash: offerAction.isGocash, isPromo: true, promoName: promoObj.key });
    dispatch(setSelectedPromoCode(promoObj.key));
    const code = promoObj.key;
    const leadcodes = insuranceOption.value === 'yes' ? [insurance.leadid] : [];
    const queryData = querydata.indexOf('#') !== -1 ? querydata : `#${querydata}`;
    const action = code ? 'promo_applied' : 'promo_removed'; // in case of removal action :- promo_removed

    const res = dispatch(
      fetchPromoData({ code, leadcodes, isGocashSelected, queryData, token, action, page_source }),
    );
    res
      .then(data => {
        if (data.error) {
          dispatch(setSelectedPromoCode(''));
          setOfferAction({ isGocash: offerAction.isGocash, isPromo: false, promoName: '' });
          setPopupContent({ title: `${promoObj.key || 'INFO'} `, content: `<div>${data.error}</div>` });
          return;
        }
        token = data.b_token;
        setData({ bookingKey, routeId, data });

        updateToken(search, history, token);

        dispatch(toggleReviewDataLoading({ isLoading: false, isError: false, reviewData: data }));

        setOfferAction({ isGocash: data.allow_both_promo_and_gocash, isPromo: false, promoName: '' });

        if (code && data && data.promo_applied && !data.promo_applied.success) {
          setPopupContent({
            title: data.promo_applied.promoname,
            content: `<div>${data.promo_applied.promomessage}</div>`,
          });
        } else if (isLoggedIn) {
          if (isGocashSelected && !data.gocash.is_gocash_applied) {
            // if go cash applied is false then disable the gocash check box
            dispatch(toggleGoCashSelection(!isGocashSelected));
          }
        }

        const eventDetails = {
          booking : {
            promoCode: promoObj.key
          },
          cta: ctaHelper(['Promo_code_applied', CTA_TYPE.BUTTON, 'Offers', 'Review'])
        }
        eventDetailsOffer.booking.offerId = `${promoObj.key}`; 
        promoObj.key !== promoObj.chunk_key && action === 'promo_applied'
          && (data && data.promo_applied && data.promo_applied.success)
          && pushOmniEvents({ eventName: 'selectOffer', details: eventDetailsOffer })
        manualPromo && promo_applied?.success?pushOmniEvents({eventName:'applyPromocode', details:eventDetails}):null;
        //TODO:- do action on base of promo response  // show popup,error
      })
      .catch(err => {
        dispatch(setSelectedPromoCode(''));
        setPopupContent({ title: `${promoObj.key || 'INFORMATION'} `, content: `<div>Sorry, unable to apply promo. Please try again.</div>` });
        setOfferAction({ isGocash: offerAction.isGocash, isPromo: false, promoName: '' });

        console.log(err);
      });
  }

  function loadPromoData(isGocash) {
    const code = selectedPromoId || '';
    const leadcodes = [];
    const queryData = querydata.indexOf('#') !== -1 ? querydata : `#${querydata}`;
    const action = code
    const res = dispatch(
      fetchPromoData({ code, leadcodes, isGocashSelected: isGocash, queryData, token, action, page_source }),
    );
    res
      .then(data => {
        if (data.error) {
          return;
        }
        token = data.b_token;
        setData({ bookingKey, routeId, data });

        updateToken(search, history, token);

        dispatch(toggleReviewDataLoading({ isLoading: false, isError: false, reviewData: data }));

        setOfferAction({ isGocash: data.allow_both_promo_and_gocash, isPromo: false, promoName: '' });
        if (isLoggedIn) {
          const isGocashApplied = data.gocash && data.gocash.is_gocash_applied ? true : false;
          dispatch(toggleGoCashSelection(isGocashApplied));
        }
      })
      .catch(err => {

        console.log(err);
      });

  }

  const onBussinessInfoChange = (evt) => {
    const { dataset, value } = evt.target;
    let info = Object.assign({}, businessInfo);
    if (dataset.val === 'phoneNumber' && isNaN(value)) {
      return;
    }
    info[dataset.val] = value;
    setBusinessInfo(info)
  }
  function loadGosafeChanges() {
    if (other_data && Object.keys(other_data).length) {
      const { go_safe, sf_en, soc_dis, soc_dis_msg, soc_dis_t } = other_data as {
        go_safe: boolean;
        sf_en: boolean;
        soc_dis: boolean;
        soc_dis_msg?: string;
        soc_dis_t?: boolean;
      };

      let type = '';
      if (go_safe) {
        type = 'goSafeMeasure';
      } else if (sf_en) {
        type = 'safetyFeature';
      } else if (soc_dis) {
        type = 'socialDistance';
      }

      switch (type) {
        case 'goSafeMeasure':
          dispatch(callGoSafeMeasure({ go_safe, soc_dis }));
          break;
        case 'socialDistance':
          dispatch(callSocialDistance());
          break;
        default:
          break;
      }
    }
  }

  const addTraveller = (data) => {
    const { name, age, gender } = data;

    let traveller = getter("traveller") || {}
    let travellerKey = `${name}-${age}-${gender}`

    if (!traveller[travellerKey]) {
      traveller[travellerKey] = {}
    }
    traveller[travellerKey] = { gender, f_name: name, age }
    //setter("traveller",traveller)

  }

  const addTravellerToSession = (id, val, text) => {
    if (!window) {
      return {}
    }
    let sessionData = sessionStorage.getItem("travellerInfo");
    let travellerInfo = sessionData ? JSON.parse(sessionData) : {}
    if (!travellerInfo || !Object.keys(travellerInfo).length) {
      travellerInfo = {};
      travellerInfo[id] = { [val]: text };

    }
    if (!travellerInfo[id]) {
      travellerInfo[id] = { [val]: text };

    }
    travellerInfo[id][val] = text;
    sessionStorage.setItem("travellerInfo", JSON.stringify(travellerInfo));
  }

  const addContactInfoToSession = (type, value) => {
    if (!window) {
      return {}
    }

    let sessionData = sessionStorage.getItem("travellerContactInfo");
    let travellerContactInfo = sessionData ? JSON.parse(sessionData) : {}
    if (!travellerContactInfo || !Object.keys(travellerContactInfo).length) {
      travellerContactInfo = {};
      travellerContactInfo[type] = value;

    }
    if (!travellerContactInfo[type]) {
      travellerContactInfo[type] = value;

    }
    travellerContactInfo[type] = value;
    sessionStorage.setItem("travellerContactInfo", JSON.stringify(travellerContactInfo));
  }
  let summaryData = {};
  if (paymentPageInfo.isPaymentPage) {
    summaryData = prepareSubmitDetailsData(reviewDataFromStore, travellerData, contactInfo);
  }

  const onGoCashToggle = () => {
    const action = !isGocashSelected ? 'gocash_applied' : 'gocash_removed';
    const code = allow_both_promo_and_gocash || (reviewDataFromStore && reviewDataFromStore.gocash && reviewDataFromStore.gocash.is_gocash_applicable) ? selectedPromoId : '';
    const leadcodes = insuranceOption.value === 'yes' ? [insurance.leadid] : [];
    const queryData = querydata.indexOf('#') !== -1 ? querydata : `#${querydata}`;

    if (selectedPromoId && !allow_both_promo_and_gocash) {
      dispatch(setSelectedPromoCode(''));
    }

    dispatch(toggleGoCashSelection(!isGocashSelected));

    const res = dispatch(
      fetchPromoData({
        code,
        leadcodes,
        isGocashSelected: !isGocashSelected,
        queryData,
        token,
        action,
        page_source
      }),
    );
    res.then(data => {
      if (data.error) {
        setPopupContent({ title: 'INFO ', content: `<div>${data.error}</div>` });
        return;
      }
      const { allow_both_promo_and_gocash, promo_applied } = data;
      token = data.b_token;
      setData({ bookingKey, routeId, data });
      updateToken(search, history, token);
      dispatch(toggleReviewDataLoading({ isLoading: false, isError: false, reviewData: data }));
      if (allow_both_promo_and_gocash && promo_applied && promo_applied.promoname) {
        dispatch(setSelectedPromoCode(code));
      }
    }).catch(err => { console.log(err); });
  }

  const signInClickEvt = (evt) => {
    pushCtaOmniEvents('Login_banner_selected', CTA_TYPE.HYPER_LINK, 'Traveller Detail Login', 'Home');
    evt.stopPropagation();
    signIn();
  }

  const onGSTBillingSuccess = (data) => {
    const { address = '', pincode = '', state = '' } = data;
    let gst_details = { 
      gst_address : address,
      gst_pincode: pincode,
      state :  state,
      save_gst_details: !isLoggedIn ? true : false
    } 
    onPayClick(gst_details)
  }

  const onGSTBillingError = () => {
    console.log('error received at parent')
  }
 

  const handlePayBtn = () => {
    // this will be called every time
    billingAddressRef?.current?.onSave();
  }


  return (
    <>
      <Helmet
        title={"Bus Booking - Online Bus Ticket Booking of all Bus types at best prices"}
        meta={
          [{ name: 'description', content: "Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices." },
          { name: 'keywords', content: "Goibibo, online bus booking, book bus online, bus booking site, Goibibo buses" },
          { property: 'og:title', content: "Bus Booking - Online Bus Ticket Booking of all Bus types at best prices" },
          { property: 'og:description', content: "Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices." },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          ]
        }
      />

      <section key="parent">
        {popupContent && Object.keys(popupContent).length && popupContent.content ? (
          <Popup
            title={popupContent.title}
            content={[
              <div
                key="reviewPopupContent"
                dangerouslySetInnerHTML={{ __html: popupContent.content }}
              ></div>,
            ]}
            onCloseClick={() => {
              setPopupContent({ title: '', content: '' });
            }}
          ></Popup>
        ) : <></>}

        <S.ReviewPageBgWrapper id="reviewPageHead">
          {alertPopupContent && Object.keys(alertPopupContent).length && alertPopupContent.content ? <AlertPopup
            popupWidth="57rem"
            isHeaderIcon={alertPopupContent.isHeaderIcon}
            footerBtn={alertPopupContent.footerBtn}
            title={alertPopupContent.title}
            contentTxt={alertPopupContent.content}
            onFooterBtnClick={alertPopupContent.onFooterBtnClick}
            buttonName={alertPopupContent.buttonName || 'OK'}
          /> : null}

          <S.HeaderWrapper>
            <S.LeftWrapper>
              <S.PageHeader>{!paymentPageInfo.isPaymentPage ? "Review your Booking" : "Payment"}</S.PageHeader>
              <S.BookingHeader>
                {src} - {dest} | <span>{doj}</span>
              </S.BookingHeader>
            </S.LeftWrapper>
            {persuasionText ? (
              <S.RightWrapper>
                <S.HeaderInfo>
                  <Icon name="TimerIcon" styleProps={{ fill: '#fff' }}></Icon>
                  <span>{persuasionText}</span>
                </S.HeaderInfo>
              </S.RightWrapper>
            ) : null}
          </S.HeaderWrapper>
        </S.ReviewPageBgWrapper>
        {/* booking page loader */}
        {/* <BookingPageLoader /> */}
        {/* <ErrorPopup /> */}
        <S.PageWrapper>

          <S.LeftWrapper>
            {paymentPageInfo.isPaymentPage && summaryData && Object.keys(summaryData).length && isDataPresentinLS ? <SubmitedDetails {...summaryData}></SubmitedDetails> : null}
            {!paymentPageInfo.isPaymentPage ? <>
              <BookingDetailCard
                {...bookingDetailCardProps}
                cancellationPolicyCB={() => {
                  const bid = reviewDataFromStore.onward_data.bid;
                  const src_vid = reviewDataFromStore.onward_data.src_voyager_id;
                  const dest_vid = reviewDataFromStore.onward_data.dest_voyager_id;
                  pushga({
                    event: ReviewEvents.actions.view_cancellation_policy,
                    eventCategory: ReviewEvents.category,
                    eventAction: ReviewEvents.actions.view_cancellation_policy,
                  });
                  const res = dispatch(fetchCancellationPolicy(bid, src_vid, dest_vid));
                  res.then(r => {
                    setPopupContent({ title: 'Cancellation Policy', content: r.data });
                  })
                    .catch(err => {
                      setPopupContent({ title: 'Cancellation Policy', content: `<div>${REVIEW_PAGE.CANCELLATION_POLICY_ERROR}</div>` });
                      console.log(err);
                    });
                }}
              />

              {/* {isLoggedIn ? <GoTribeBanner /> : <></>} */}

              {goTribeCoinData && Object.keys(goTribeCoinData).length && goTribeCoinData.msg ? <ReviewGoTribe {...goTribeCoinData}></ReviewGoTribe> : null}

              {review_ps && Object.keys(review_ps).length && review_ps.tg_list && review_ps.tg_list.length ? <S.UserChoice>
                <S.UserChoiceTxt>{review_ps.t}</S.UserChoiceTxt>
                <S.UserChoiceTag>
                  {review_ps.tg_list && review_ps.tg_list.map((tagName) => {
                    return (<S.UserTag key={tagName}>
                      <span>{tagName}</span>
                    </S.UserTag>)
                  })}
                </S.UserChoiceTag>
              </S.UserChoice>
                : null}
              {!go_safe && soc_dis ? <GoSafeMeasures data={goSafeSocialData} /> : null}
              {go_safe ? <GoSafeMeasures data={goSafeData} /> : null}
              <GoSafeImpInfo data={review_info} />
            </> : <></>}

            <S.ReviewCardWrap id="reviewBlock">

              {/* insurance */}
              {!paymentPageInfo.isPaymentPage ? <>
                {insurance && Object.keys(insurance).length ? (
                  <CollapsibleComponent
                    idn="insurance"
                    heading={insurance.subtitle}
                    onCollapsedClick={() => {
                      setInsuranceOption({ collapsed: !insuranceOption.collapsed, err: insuranceOption.err, value: insuranceOption.value, isLoading: insuranceOption.isLoading });
                    }}
                    childComponent={!insuranceOption.collapsed ? <>
                      <InsuranceBlock
                        insuranceData={insurance}
                        insuranceRequired={false}
                        insuranceOption={insuranceOption}
                        onInsurnaceOptionSelect={option => {
                          setInsuranceOption({ value: option, err: '', collapsed: insuranceOption.collapsed, isLoading: true });
                          const code = selectedPromoId;
                          const leadcodes = option === 'yes' ? [insurance.leadid] : [];
                          const queryData =
                            querydata.indexOf('#') !== -1 ? querydata : `#${querydata}`;
                          const action = option === 'yes' ? 'insurance_applied' : 'insurance_removed';
                          const res = dispatch(
                            fetchPromoData({
                              code,
                              leadcodes,
                              isGocashSelected,
                              queryData,
                              token,
                              action,
                              page_source
                            }),
                          );
                          res.then(data => {
                            if (data.error) {
                              setInsuranceOption({ value: '', err: '', collapsed: insuranceOption.collapsed, isLoading: false });
                              setPopupContent({ title: 'INFO ', content: `<div>${data.error}</div>` });
                              return;
                            }
                            token = data.b_token;
                            setData({ bookingKey, routeId, data });
                            updateToken(search, history, token);
                            dispatch(toggleReviewDataLoading({ isLoading: false, isError: false, reviewData: data }));
                            setInsuranceOption({ value: option, err: '', collapsed: insuranceOption.collapsed, isLoading: false });
                          })
                            .catch(err => {
                              setInsuranceOption({ value: '', err: '', collapsed: false, isLoading: false });
                              setPopupContent({ title: 'INFORMATION ', content: `<div>${REVIEW_PAGE.INSURANCE_API_ERROR}</div>` });
                              console.log(err);
                            });
                        }}
                      />
                    </> : <></>}
                  />
                ) : <></>}
              
                {reviewDataFromStore?.go_tribe?.inLineCard && Object.keys(reviewDataFromStore?.go_tribe?.inLineCard)?.length > 0 
                && <S.GoTribeReviewComponent>
                    <GoTribeReview
                      header={reviewDataFromStore?.go_tribe?.inLineCard[0]?.data?.header}
                      subHeader={reviewDataFromStore?.go_tribe?.inLineCard[0]?.data?.subHeader}
                      imageUrl={reviewDataFromStore?.go_tribe?.inLineCard[0]?.data?.imageUrl}
                      benefits={reviewDataFromStore?.go_tribe?.inLineCard[0]?.data?.benefits}
                      tier={reviewDataFromStore?.go_tribe?.currentTire}
                      lob="bus"
                      isMobile={false}
                      cardId={reviewDataFromStore?.go_tribe?.inLineCard[0]?.cardId}
                    />
                  </S.GoTribeReviewComponent>
                }

                {/* traveller details */}
                <CollapsibleComponent
                  idn="travellerdetails"
                  heading="Traveller Details"
                  onCollapsedClick={() => {
                    setCollapsedItems({ ...collapsedItems, traveller: !collapsedItems.traveller });
                  }}
                  infoText={{ text: "Please make sure you enter the Name as per your Govt. photo id" }}
                  subHeader={!isLoggedIn ?
                    <SignInTag tagText='Login to speed up your booking process' onClick={signInClickEvt} /> : <></>}
                  childComponent={!collapsedItems.traveller ? <>
                    <TravellerBlock
                      seatsSelected={seatsSelected}
                      travellerInfo={travellerData}
                      pax_prefill={pax_prefill}
                      onPaxSelect={params => {
                        const { gender, f_name, age, id, travellerNumber } = params;
                        let travellernum = parseInt(travellerNumber, 10) - 1;
                        const data = [...travellerData];
                        let travellerObj = Object.assign({}, data[travellernum]);
                        if (f_name) {
                          travellerObj['name'] = f_name;
                        }
                        if (age) {
                          travellerObj['age'] = age;
                        }
                        if (gender) {
                          travellerObj['gender'] = gender;
                        }
                        data[travellernum] = travellerObj;
                        setTravellerData(data);
                      }}
                      onChange={evt => {
                        let { travellernum, val } = evt.target.dataset;
                        const text = evt.target.value;

                        if (val === 'age' && isNaN(text)) {
                          return;
                        }
                        travellernum = parseInt(travellernum, 10) - 1;
                        const data = [...travellerData];
                        let travellerObj = Object.assign({}, data[travellernum]);
                        travellerObj[val] = text;
                        data[travellernum] = travellerObj;

                        setTravellerData(data);
                        addTravellerToSession(+travellernum + 1, val, text);
                      }}
                      onGenderChange={(value, travellerNumber, type) => {
                        const data = [...travellerData];
                        travellerNumber = parseInt(travellerNumber, 10) - 1;
                        let travellerObj = Object.assign({}, data[travellerNumber]);
                        travellerObj[type] = value;
                        data[travellerNumber] = travellerObj;
                        setTravellerData(data);
                        addTravellerToSession(+travellerNumber + 1, type, value);

                      }}
                    />
                  </> : <></>}
                />

                <CollapsibleComponent
                  idn="contactDetails"
                  heading="Contact Details"
                  infoText={{ text: "Your E-ticket and updates will be sent to the following details" }}
                  onCollapsedClick={() => {
                    setCollapsedItems({ ...collapsedItems, contactDetail: !collapsedItems.contactDetail });
                  }}
                  childComponent={!collapsedItems.contactDetail ? <>
                    <TravellerContactForm
                      contactInfo={contactInfo}
                      onChange={evt => {
                        let { val } = evt.target.dataset;
                        if (val === "catCardNumber" || val === "srCitizenCardNumber") {
                          let categoryInfo = Object.assign({}, categoryCardInfo);
                          categoryInfo[val] = evt.target.value
                          setCategorycardInfo(categoryInfo);
                          return;
                        }
                        let contactObj = Object.assign({}, contactInfo);
                        contactObj[val] = evt.target.value;
                        if (val === 'contactNum' && isNaN(contactObj[val])) {
                          return;
                        }
                        setContactInfo(contactObj);
                        addContactInfoToSession(val, evt.target.value)
                      }}
                      srCitizen={other_data.sr_citizen_req}
                      catCard={other_data.cat_card_required}
                      categoryCardInfo={categoryCardInfo} />
                  </> : <></>
                  }
                />
                {/* {GSTIN billing details} */}
                <div style={{marginBottom: '1.5rem'}}>
                  <BillingDetailsDweb
                    onError={onGSTBillingError}
                    onSuccess={onGSTBillingSuccess}
                    ref={billingAddressRef}
                    platform={'dweb'}
                    lobName={'bus'}     
                  />
                </div>
                {/* trip type */}
                <CollapsibleComponent
                  idn="tripType"
                  heading="Trip Type"
                  onCollapsedClick={() => {
                    setTripType({ collapsed: !tripType.collapsed, type: tripType.type });
                  }}
                  childComponent={!tripType.collapsed ? <>
                    <TripType
                      onBusinessInfoChange={(evt) => { onBussinessInfoChange(evt) }}
                      businessInfo={businessInfo}
                      tripType={tripType.type}
                      onTripChange={type => {
                        setTripType({ type: type, collapsed: false });
                      }}
                    />
                  </> : <></>}
                />
                <S.PayButton onClick={handlePayBtn}>Pay ₹ {totalPayFare}</S.PayButton>
              </> : <></>}

              {/* payment modes */}
              <S.PaymentCard style={{ opacity: paymentPageInfo.isPaymentPage ? 1 : 0 }}>
                <S.paymentHeaderInput type="checkbox" id="paymentmodes"></S.paymentHeaderInput>
                <S.PaymentTabLabel htmlFor="paymentmodes">
                  <span>Payment Modes</span>
                </S.PaymentTabLabel>
                <S.PaymentTabContent id="gi_paymentframe"></S.PaymentTabContent>
              </S.PaymentCard>
            </S.ReviewCardWrap>
          </S.LeftWrapper>

          {/* right content */}
          <S.RightWrapper>

            {/* price card */}
            <CollapsibleComponent
              idn="fareprice"
              heading="PRICE"
              onCollapsedClick={() => {
                setCollapsedItems({ ...collapsedItems, fare: !collapsedItems.fare });
                pushga({
                  event: ReviewEvents.actions.price_detail,
                  eventCategory: ReviewEvents.category,
                  eventAction: ReviewEvents.actions.price_detail,
                });
              }}
              childComponent={
                <FarePrice
                  fareBreakup={fareBreakup}
                  totalPayFare={totalPayFare}
                  isLoggedIn={paymentPageInfo.isPaymentPage ? true : isLoggedIn}
                  isCollapsed={collapsedItems.fare}
                />
              }
            />


            {!paymentPageInfo.isPaymentPage && isLoggedIn && reviewDataFromStore.gocash ?
              <GoCash
                goCash={reviewDataFromStore.gocash}
                onGoCashToggle={onGoCashToggle}
                isGocashSelected={isGocashSelected}
              />
              : <></>}

            {/* {!paymentPageInfo.isPaymentPage && isLoggedIn && reviewDataFromStore.gocash ? */}
          
            <S.GoTribeSideStripComponent>
          { reviewDataFromStore?.go_tribe?.bottomStrip && Object.keys(reviewDataFromStore?.go_tribe?.bottomStrip)?.length > 0 && <GoTribeSideStrip
            lob="bus"
            heading={reviewDataFromStore?.go_tribe?.bottomStrip[0]?.data?.header}
            image={reviewDataFromStore?.go_tribe?.bottomStrip[0]?.data?.iconUrl}
            text={reviewDataFromStore?.go_tribe?.bottomStrip[0]?.data?.message} 
            isCLM={reviewDataFromStore?.go_tribe?.bottomStrip[0]?.cardId =='CLM_BOTTOM_STRIP' ? true : false }
            />
            }
              {/* : <></>} */}
              </S.GoTribeSideStripComponent>
            {/* offer card */}
            {!paymentPageInfo.isPaymentPage ?
              <CollapsibleComponent
                idn="offercard"
                heading="OFFERS"
                onCollapsedClick={() => {
                  setCollapsedItems({ ...collapsedItems, offer: !collapsedItems.offer });
                }}
                childComponent={!collapsedItems.offer ? <>
                  <ReviewOfferCard
                    isLoggedIn={isLoggedIn}
                    offerAction={offerAction}
                    promos={promos}
                    redDeal={redDeal}
                    selectedPromoId={selectedPromoId}
                    promoDisplayCount={PROMO_DISPLAY_COUNT}
                    promo_applied={promo_applied}
                    onPromoRemove={() => {
                      onPromoClick({ chunk_key: '', key: '' })
                    }}
                    goCash={reviewDataFromStore.gocash}
                    isGocashSelected={isGocashSelected}
                    onGoCashToggle={onGoCashToggle}
                    onPromoSelect={onPromoClick}
                    onManualPromoClick={(promoValue, manual) => {
                      onPromoClick({ chunk_key: promoValue, key: promoValue }, manual)
                    }}
                  />
                </> : <></>}
              /> : <></>}
          </S.RightWrapper>
        </S.PageWrapper>
      </section>
    </>
  );
};

export default Review;


const getBookingDetailsCardProps = (data) => {
  const {
    BusType: busType,
    TravelsName: operatorName,
    seatsSelected,
    BoardingPoint,
    DroppingPoint,
    other_data
  } = data;
  return {
    busType,
    operatorName,
    selectedSeats: (function () {
      let seats = [];
      for (const i in seatsSelected) {
        if (seatsSelected.hasOwnProperty(i)) {
          seats.push(seatsSelected[i].seat);
        }
      }
      return seats;
    })(),
    bpDetail: {
      dateTime: dateformat(
        new Date(BoardingPoint.BPTime.substring(0, BoardingPoint.BPTime.length - 1)),
        'h:MM TT, dS mmm yyyy',
      ),
      name: BoardingPoint.BPN,
      content: BoardingPoint.BPAddress,
    },
    dpDetail: {
      dateTime: dateformat(
        new Date(DroppingPoint.DPTime.substring(0, DroppingPoint.DPTime.length - 1)),
        'h:MM TT, dS mmm yyyy',
      ),
      name: DroppingPoint.DPN,
      content: DroppingPoint.DPAddress,
    },
    other_data
  };
}

const getTravllerInitInfo = (seatsSelected) => {
  if (!window) {
    return {}
  }

  let sessionData = sessionStorage.getItem("travellerInfo");
  let travellerInfo = sessionData ? JSON.parse(sessionData) : {}

  let data = [];
  if (seatsSelected) {
    for (const i in seatsSelected) {
      if (seatsSelected.hasOwnProperty(i)) {
        data.push({
          name: travellerInfo[+i + 1] && travellerInfo[+i + 1]['name'] ? travellerInfo[+i + 1]['name'] : '',
          age: travellerInfo[+i + 1] && travellerInfo[+i + 1]['age'] ? travellerInfo[+i + 1]['age'] : '',
          gender: travellerInfo[+i + 1] && travellerInfo[+i + 1]['gender'] ? travellerInfo[+i + 1]['gender'] : '',
          nameErr: '',
          ageErr: '',
          genderErr: '',
          ageMaxLength: 2,
          seat: seatsSelected[i].seat,
        });
      }
    }
  }
  return data;
}

const getInitContactInfo = () => {
  if (typeof window == "undefined") {
    return {
      email: '',
      countryCode: '+91',
      contactNum: '',
      emailErr: '',
      contactNumMaxLength: 10,
      contactNumErr: '',

    }
  }
  let sessionData = sessionStorage.getItem("travellerContactInfo");
  let travellerContactInfo = sessionData ? JSON.parse(sessionData) : {}

  return {
    email: travellerContactInfo && travellerContactInfo.email ? travellerContactInfo.email : '',
    countryCode: '+91',
    contactNum: travellerContactInfo && travellerContactInfo.contactNum ? travellerContactInfo.contactNum : '',
    emailErr: '',
    contactNumMaxLength: 10,
    contactNumErr: '',

  };
}

const getFareBreakup = (fareBreakup, faremapKeysInfo) => {
  //TODO:-faremapKeysInfo pending from backend to server in review and promo discount api
  const fareBreakupObj = {};
  let fareMap = {};
  //let baseFare={price:"",items:[]},discount={price:"",items:[]}, finalPrice={price:"",items:[]}
  // finalPrice.items=fareBrekaup;
  //  finalPrice.price=fareBrekaup[0].v;
  for (const i in fareBreakup) {
    if (fareBreakup.hasOwnProperty(i) && fareBreakup[i].v !== 0) {
      fareBreakupObj[fareBreakup[i].k] = fareBreakup[i].v;
    }
  }
  for (const type in faremapKeysInfo) {
    if (faremapKeysInfo.hasOwnProperty(type)) {
      fareMap[type] = { items: [] };

      for (let k in faremapKeysInfo[type]) {
        if (fareBreakupObj[faremapKeysInfo[type][k]]) {
          fareMap[type].items.push({
            k: faremapKeysInfo[type][k],
            v: fareBreakupObj[faremapKeysInfo[type][k]],
          });
        }
        if (
          fareBreakupObj[faremapKeysInfo[type][k]] ||
          fareBreakupObj[faremapKeysInfo[type][k]] == 0
        ) {
          delete fareBreakupObj[faremapKeysInfo[type][k]];
        }
      }
    }
  }

  return { fareMap, fareBreakupObj };
}

export const getPaymentFareBreakup = (fareBreakup, faremapKeysInfo) => {
  const fareBreakupObj = {};
  let fareMap = {};
  //let baseFare={price:"",items:[]},discount={price:"",items:[]}, finalPrice={price:"",items:[]}
  // finalPrice.items=fareBrekaup;
  //  finalPrice.price=fareBrekaup[0].v;
  for (const i in fareBreakup) {
    if (fareBreakup.hasOwnProperty(i) && fareBreakup[i].value !== 0) {
      fareBreakupObj[fareBreakup[i].key] = fareBreakup[i].value;
    }
  }
  for (const type in faremapKeysInfo) {
    if (faremapKeysInfo.hasOwnProperty(type)) {
      fareMap[type] = { items: [] };

      for (let k in faremapKeysInfo[type]) {
        if (fareBreakupObj[faremapKeysInfo[type][k]]) {
          fareMap[type].items.push({
            k: faremapKeysInfo[type][k],
            v: fareBreakupObj[faremapKeysInfo[type][k]],
          });
        }
        if (
          fareBreakupObj[faremapKeysInfo[type][k]] ||
          fareBreakupObj[faremapKeysInfo[type][k]] == 0
        ) {
          delete fareBreakupObj[faremapKeysInfo[type][k]];
        }
      }
    }
  }
  return { fareMap, fareBreakupObj };
}

const updateToken = (search, history, token) => {
  const urlParams = search.replace(/(token=).*?(&)/, '$1' + token + '$2');
  history.replace(urlParams);
}

const getSubmitProps = (data, contactInfo, travellerData, other_data) => {
  let fareTotal = data.total_fare;
  const udf1 = data.udf1;
  const credits = data.max_gocash_amount;
  // if(credits){
  //   fareTotal = +fareTotal + credits;
  // }
  const mobile = contactInfo.contactNum;
  const email = contactInfo.email;
  const isSeniorCitizen = other_data.sr_citizen_req;
  const isCatCard = other_data.cat_card_required;
  return { fareTotal, udf1, mobile, email, credits, isSeniorCitizen, isCatCard };
}

const prepareSubmitDetailsData = (reviewData, travellerData, contactInfo) => {
  if (!reviewData || !reviewData.onward_data) {
    return {}
  }
  const data = reviewData.onward_data;

  let summaryData = {
    operatorName: data.TravelsName,
    busType: data.BusType,
    bpViewTime: function () {
      let viewTime = "";
      let dateStr = data.BoardingPoint.BPTime && data.BoardingPoint.BPTime.indexOf('Z') !== -1 ? data.BoardingPoint.BPTime.slice(0, -1) : data.BoardingPoint.BPTime
      if (data.BoardingPoint && data.BoardingPoint.BPTime) {
        viewTime = dateformat(getDateObj(dateStr), ' h:MM TT  dS mmmm yyyy')
      }
      return viewTime;
    }(),
    bpViewAddress: function () {
      let viewAddress = "";
      if (data.BoardingPoint && data.BoardingPoint.BPAddress) {
        viewAddress = data.BoardingPoint.BPAddress;
      }
      return viewAddress;
    }(),
    dpViewTime: function () {
      let viewTime = "";
      let dateStr = data.DroppingPoint.DPTime && data.DroppingPoint.DPTime.indexOf('Z') !== -1 ? data.DroppingPoint.DPTime.slice(0, -1) : data.DroppingPoint.DPTime

      if (data.DroppingPoint && data.DroppingPoint.DPTime) {
        viewTime = dateformat(getDateObj(dateStr), ' h:MM TT  dS mmmm yyyy')
      }
      return viewTime;
    }(),
    dpViewAddress: function () {
      let viewAddress = "";
      if (data.DroppingPoint && data.DroppingPoint.DPAddress) {
        viewAddress = data.DroppingPoint.DPAddress;
      }
      return viewAddress;
    }(),
    travellersName: function () {
      let travellerNameArr = [];
      if (travellerData && travellerData.length) {
        travellerNameArr = travellerData.map(function (traveller) {
          //  return traveller.name.split(" ")[0];
          return traveller.name;

        })
      }
      return travellerNameArr;
    }(),
    primaryContactName: function () {
      // let name="";
      // if(reviewData.travellerInfo && reviewData.travellerInfo.length){
      //   name = reviewData.travellerInfo[0].name.split(" ")[0];
      // }
      let name = travellerData[0].name;
      return name;
    }(),
    primaryContactNumber: contactInfo.contactNum ? contactInfo.contactNum : '',
    primaryEmailId: contactInfo ? contactInfo.email : '',
    go_safe: data.other_data.go_safe,
    sf_en: data.other_data.sf_en
  }
  return summaryData;
}

const atLeastTravellerAge13 = (traveller, isRSRTC) => {

  let isValid = false;
  if (isRSRTC) {
    for (let i in traveller) {
      if (traveller[i].age >= 13) {
        isValid = true;
      }
    }
  }
  return isValid;
}

